import React from 'react';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';

import ComponentView from './ComponentView';
import TableView from './TableView';

const GroupRiskAssessment = () => {
	const location = useLocation();
	const {componentId = null} = queryString.parse(location.search);

	if (componentId !== null) return <ComponentView />;
	return <TableView />;
};

export default GroupRiskAssessment;
